<template>
  <div
    @mouseover="isMobile ? null : showMenu()"
    @mouseleave="isMobile ? null : hideMenu()"
    @click="isMobile ? (openMenu = !openMenu) : null"
    class="cursor-pointer"
  >
    <div class="relative menu">
      <div
        class="menu group inline-flex items-center space-x-1 text-base leading-5 font-medium hover:text-blue-500 focus:outline-none transition ease-in-out duration-150"
        :class="dynamicClasses"
      >
        <!-- See if they passed title slot -->
        <template v-if="slotTitle">
          <router-link v-if="!!target" :to="target" :class="titleClass">
            <!-- @slot Allows you to pass a slot instead of a prop for the menu title. Useful for using an image or div instead of text. -->
            <slot name="title" />
          </router-link>
          <slot v-else name="title" />
        </template>
        <!-- Otherwise use title prop -->
        <router-link v-else-if="!!target" :to="target" :class="titleClass">{{ title }}</router-link>
        <span v-else>{{ title }}</span>

        <template v-if="slotPassed && !slotTitle">
          <svg
            :class="openMenu ? 'text-blue-500' : 'text-gray-200'"
            class="h-5 w-5 group-hover:text-blue-500 group-focus:text-gray-500 transition ease-in-out duration-150"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
              clip-rule="evenodd"
            />
          </svg>
        </template>
        <div v-else class="w-2"></div>
      </div>
    </div>

    <!-- mobile version of menu panels -->
    <div v-if="isMobile">
      <div v-if="openMenu" class="py-4">
        <!-- @slot Slot for including MenuItem components inside your menu dropdown. -->
        <slot />
      </div>
    </div>

    <!-- full multi-column menu -->
    <menu-body-full v-else-if="full || columns > 3" :slotPassed="slotPassed" :openMenu="openMenu" :columns="columns" :footer="footer">
      <slot />

      <template #footer>
        <!-- @slot Create a footer to show at the bottom of the dropdown menu's body. -->
        <slot name="footer" />
      </template>
    </menu-body-full>

    <!-- multi-column menu -->
    <menu-body-multi v-else-if="columns > 1" :slotPassed="slotPassed" :openMenu="openMenu" :columns="columns">
      <slot />
    </menu-body-multi>

    <!-- single column menu -->
    <menu-body-single v-else :slotPassed="slotPassed" :openMenu="openMenu" :bodyClass="bodyClass">
      <slot />
    </menu-body-single>
  </div>
</template>

<script>
import MenuBodySingle from './MenuBodySingle.vue'
import MenuBodyMulti from './MenuBodyMulti.vue'
import MenuBodyFull from './MenuBodyFull.vue'
export default {
  components: {
    MenuBodySingle,
    MenuBodyMulti,
    MenuBodyFull
  },
  props: {
    /**
     * Used to specify the menu's title.
     */
    title: {
      type: String,
      default: 'Menu Title'
    },
    /**
     * Sets the URL for this menu item.
     */
    target: {
      type: String,
      default: null
    },
    /**
     * Specify number of columns.
     */
    columns: {
      type: Number,
      default: 1
    },
    /**
     * Make the menu go full width of the navbar.
     */
    full: {
      type: Boolean,
      default: false
    },
    /**
     * Specify CSS classes to apply to the title (like a color or uppercase).
     */
    titleClass: {
      type: String
    },
    /**
     * Specify CSS classes to apply to the body of the flyout menu.
     */
    bodyClass: {
      type: String
    }
  },
  data() {
    return {
      openMenu: false,
      isMobile: false,
      closeMenu: null
    }
  },
  computed: {
    slotTitle() {
      return !!(this.$slots.title && this.$slots.title())
      // let title = this.title

      // if (!!this.$slots.title && !!this.$slots.title[0]) {
      //   title = this.$slots.title
      // }

      // return title
    },
    dynamicClasses() {
      let classes = ''
      classes += this.openMenu ? ` text-blue-500` : ` text-gray-500`
      classes += this.isMobile ? ` h-6` : ` h-14`
      return classes
    },
    slotPassed() {
      return !!(this.$slots.default && this.$slots.default())
    },
    footer() {
      return !!(this.$slots.footer && this.$slots.footer())
    }
  },
  methods: {
    showMenu() {
      clearTimeout(this.closeMenu)
      this.openMenu = true
    },
    hideMenu() {
      this.closeMenu = setTimeout(() => {
        this.openMenu = false
      }, 50)
    },
    mq() {
      this.isMobile = window.matchMedia('(max-width: 770px)').matches
      // console.log(this.isMobile)
    }
  },
  created() {
    this.mq()
    window.addEventListener('resize', this.mq)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.mq)
  }
}
</script>

<style lang="postcss">
a.menu-link {
  @apply -m-3 p-3 block rounded-md transition ease-in-out duration-150;
}
a.menu-link:hover {
  @apply bg-blue-50;
}
a.menu-link p.title {
  @apply text-base leading-6 font-medium text-gray-900 m-0;
}
a.menu-link p.descr {
  @apply text-sm leading-5 text-gray-500 m-0;
}
</style>
